import type { SVGProps } from 'react';

const SvgFavoritesAddedTo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12.008 20.1c-.77 0-1.54-.29-2.12-.88l-5.36-5.36a5.17 5.17 0 0 1-1.51-4.05c.11-1.51.88-2.89 2.1-3.8 1.36-1.01 3.23-1.26 4.88-.66.8.29 1.46.73 2 1.31.54-.58 1.2-1.02 2-1.31 1.65-.6 3.53-.35 4.88.66 1.22.91 1.99 2.3 2.1 3.8.11 1.51-.44 2.98-1.51 4.05l-5.36 5.36a3 3 0 0 1-2.12.88z"
    />
  </svg>
);
export default SvgFavoritesAddedTo;
